import React, { useEffect, useState } from "react";
import axios from "axios";
import { notify } from "../../../functions/function";
import logo from "../../../../src/assets/icons/iStaffLogo.png";
import { iStaffBaseURL } from "../../../constants/Urls";
import { connect } from "react-redux";
import MDSpinner from "react-md-spinner";
import { COLORS } from "../../../constants/Colors";

import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";

const Login = (props) => {
  // const [userToken, setUserToken] = useState(null);
  const [loginDetails, setLoginDetails] = useState({
    email: "",
    password: "",
    check_textInputChange: false,
    secureTextEntry: true,
  });
  const [loginState, setLoginState] = useState({ isLoading: false });
  const [mounted, setMounted] = useState(true);
  const [errors, setErrors] = useState({
    emailPasswordErrors: "",
    notAuthorised: false,
    otherErrors: null,
  });

  useEffect(() => {
    if (errors.emailPasswordErrors === 400) {
      notify(
        "Incorrect Username or Password",
        "Please provide login details or click forgotten password",
        "danger"
      );
    } else if (errors.notAuthorised) {
      notify(
        "Unauthorised User",
        "User doesnt have valid authorisation",
        "danger"
      );
    } else if (errors.otherErrors !== null) {
      notify(
        "Error Occured",
        "Please type your login details and login again",
        "danger"
      );
    }
  }, [errors]);

  const emailInputChange = (e) => {
    if (e.length !== 0) {
      setLoginDetails({
        ...loginDetails,
        email: e.currentTarget.value,
        check_textInputChange: true,
      });
    } else {
      setLoginDetails({
        ...loginDetails,
        email: e.currentTarget.value,
        check_textInputChange: false,
      });
    }
  };
  const handleSignIn = () => {
    if (mounted) {
      setLoginState({ isLoading: true });

      axios
        .post(
          iStaffBaseURL + "/login/",
          {
            email: loginDetails.email,
            password: loginDetails.password,
          },
          {
            headers: {},
          }
        )
        .then((response) => {
          if (response.data.user.is_handler || response.data.user.is_client) {
            window.sessionStorage.setItem("userToken", response.data.key);
            window.sessionStorage.setItem(
              "isHandler",
              response.data.user.is_handler
            );
            window.sessionStorage.setItem(
              "isClient",
              response.data.user.is_client
            );

            props.dispatch({
              type: "SIGNIN",
              userToken: response.data.key,
              isHandler: response.data.user.is_handler,
              isClient: response.data.user.is_client,
              userData: response.data.user,
            });

            if (response.data.user.is_handler) {
              props.history.push("/handler/placements");
            } else if (response.data.user.is_client) {
              props.history.push("/clientpage/clienttimesheets");
            }
          } else {
            props.dispatch({ type: "SIGNOUT" });
            setErrors({
              notAuthorised: true,
            });
            setLoginState({ isLoading: false });
          }
        })
        .catch((error) => {
          if (!error.response) {
            setErrors({
              otherErrors: "Unknown Error",
            });
          } else if (error.response.status === 400) {
            setErrors({
              otherErrors: "Unknown Error",
            });
          } else if (error.response.status === 400) {
            setErrors({
              emailPasswordErrors: 400,
            });
          } else {
            setErrors({
              otherErrors: error.response.status,
            });
          }
          setLoginState({ isLoading: false });
        });
    }
    return () => {
      setMounted(false);
    };
  };
  const passwordInputChange = (val) => {
    setLoginDetails({
      ...loginDetails,
      password: val.currentTarget.value,
    });
  };

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="8">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm>
                    <h1>Login</h1>

                    <p className="text-muted">Sign In to your account</p>

                    <CInputGroup className="mb-3">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-user" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="text"
                        placeholder="Username"
                        autoComplete="username"
                        onChange={(e) => {
                          emailInputChange(e);
                        }}
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-lock-locked" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                        onChange={(val) => passwordInputChange(val)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSignIn();
                          }
                        }}
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol>
                        {loginState.isLoading ? (
                          <div style={{ transform: "translate(15%, 0%)" }}>
                            {" "}
                            <MDSpinner
                              color1={COLORS.iStaffGreen}
                              style={{ paddingLeft: "1000" }}
                            />{" "}
                          </div>
                        ) : (
                          <CButton
                            color="primary"
                            className="px-4"
                            onClick={() => {
                              handleSignIn();
                            }}
                          >
                            Login{" "}
                          </CButton>
                        )}
                      </CCol>
                      <CCol xs="6" className="text-right">
                        <CButton color="link" className="px-0">
                          Forgot password?
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
              <CCard
                className="text-white bg-white py-5 d-md-down-none"
                style={{ width: "44%" }}
              >
                <CCardBody className="text-center">
                  <div>
                    <img src={logo} alt="Logo" style={{ height: 200 }} />;
                    <hr />
                    <p style={{ color: "#768192" }}>
                      Welcome to the iStaff Handler Login Page
                    </p>
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default connect()(Login);
